import { useCallback, useMemo, useState } from "react"
import { useFetchPendingSubscriptionEventsQuery } from "../../../../../redux/queries"
import { PendingSubscriptionEvent } from "../../../../../types"
import { ActivityHistorySkeleton } from "../../../skeletons"
import EmailViewerModal from "../../../email-viewer-modal"
import If from "../../../if"
import EmailRow from "./row"

type Props = {
  subscriptionId: number
}

const DreamRateEmailHistory = ({ subscriptionId }: Props) => {
  const [emailId, setEmailId] = useState<string | null>(null)
  const { data: events = [], isFetching } =
    useFetchPendingSubscriptionEventsQuery({ pending_id: subscriptionId })

  // Filter for only email events
  const emailEvents = useMemo(
    () =>
      events.filter(
        (event: PendingSubscriptionEvent) =>
          event.event_type === "pending_subscription.lo_alert_email" ||
          event.event_type === "pending_subscription.user_alert_email"
      ),
    [events]
  )

  const sortedEvents = useMemo(
    () => [...emailEvents].sort((a, b) => b.created - a.created),
    [emailEvents]
  )

  const handleOpenEmail = (emailId: string) => {
    setEmailId(emailId)
  }

  const handleCloseEmail = useCallback(() => setEmailId(null), [setEmailId])

  return (
    <>
      <If
        condition={isFetching}
        then={<ActivityHistorySkeleton rows={3} className="mt-3" />}
        elseCondition={sortedEvents.length > 0}
        else={
          <>
            {sortedEvents.map(
              (event: PendingSubscriptionEvent, idx: number) => (
                <EmailRow
                  key={event.id}
                  event={event}
                  onOpenEmail={handleOpenEmail}
                  connectorVisible={idx < sortedEvents.length - 1}
                />
              )
            )}
          </>
        }
        default={
          <div className="mt-3 text-neutral-500">No email activity yet.</div>
        }
      />

      <EmailViewerModal
        open={!!emailId}
        id={emailId!}
        title="Email notification"
        noDataText="No email found."
        onClose={handleCloseEmail}
      />
    </>
  )
}

export default DreamRateEmailHistory
